import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "environment"

  switch(event: CustomEvent) {
    const { host, name } = event.detail
    
    if (host) {
      this.send("switch", { host, name }, () => {
        // Native app will handle the logic
      })
    }
  }
}
